'use strict';

var _classCallCheck = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var Type = /*#__PURE__*/function () {
  function Type(major, name, terminal) {
    _classCallCheck(this, Type);

    this.major = major;
    this.majorEncoded = major << 5;
    this.name = name;
    this.terminal = terminal;
  }

  _createClass(Type, [{
    key: "toString",
    value: function toString() {
      return "Type[".concat(this.major, "].").concat(this.name);
    }
  }, {
    key: "compare",
    value: function compare(typ) {
      return this.major < typ.major ? -1 : this.major > typ.major ? 1 : 0;
    }
  }]);

  return Type;
}();

Type.uint = new Type(0, 'uint', true);
Type.negint = new Type(1, 'negint', true);
Type.bytes = new Type(2, 'bytes', true);
Type.string = new Type(3, 'string', true);
Type.array = new Type(4, 'array', false);
Type.map = new Type(5, 'map', false);
Type.tag = new Type(6, 'tag', false);
Type.float = new Type(7, 'float', true);
Type.false = new Type(7, 'false', true);
Type.true = new Type(7, 'true', true);
Type.null = new Type(7, 'null', true);
Type.undefined = new Type(7, 'undefined', true);
Type.break = new Type(7, 'break', true);

var Token = /*#__PURE__*/function () {
  function Token(type, value, encodedLength) {
    _classCallCheck(this, Token);

    this.type = type;
    this.value = value;
    this.encodedLength = encodedLength;
    this.encodedBytes = undefined;
  }

  _createClass(Token, [{
    key: "toString",
    value: function toString() {
      return "Token[".concat(this.type, "].").concat(this.value);
    }
  }]);

  return Token;
}();

exports.Token = Token;
exports.Type = Type;